document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".read-more-btn");
  const desc = document.querySelector(".product__description-fixed");

  if (!btn || !desc) return;

  const showMoreText = btn.dataset.showMore;
  const showLessText = btn.dataset.showLess;

  // 🔹 Kolla om texten är längre än 3 rader
  if (desc.scrollHeight <= desc.clientHeight) {
    btn.style.display = "none";
    return;
  }

  btn.addEventListener("click", function () {
    desc.classList.toggle("clamped");

    if (desc.classList.contains("clamped")) {
      btn.textContent = showMoreText;
    } else {
      btn.textContent = showLessText;
    }
  });
});